import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  AddressFormValidations,
  Button,
  ButtonWithSpinner,
  InputWithLabel,
  Modal,
  PhonePrefixSelector,
  Text,
  validateEmail,
} from '@reveni-io/reveni-ui'

import LanguageSelector from './LanguageSelector/LanguageSelector'
import * as Styles from './styles'

const EditCustomerDetailModal = ({ show, onClose, customerDetail, onEditCustomer, loading, supportedLanguages }) => {
  const { t } = useTranslation()
  const [customer, setCustomer] = useState(customerDetail || {})

  useEffect(() => {
    if (show && !loading) {
      setCustomer(customerDetail)
    }
  }, [customerDetail, loading, show])

  const handleChangeEmail = e => {
    setCustomer({ ...customer, email: e.target.value })
  }

  const handleChangePhonePrefix = e => {
    setCustomer({
      ...customer,
      phone: { ...customer.phone, prefix: e.target.value },
    })
  }

  const handleChangePhoneNumber = e => {
    setCustomer({
      ...customer,
      phone: { ...customer.phone, number: e.target.value },
    })
  }

  const handleChangeLanguage = language => {
    setCustomer({ ...customer, language })
  }

  const handleSave = () => {
    onEditCustomer(customer)
  }

  const isPhoneValid = AddressFormValidations.validatePhone(`+${customer?.phone?.prefix} ${customer?.phone?.number}`)
  const isFormValid = validateEmail(customer?.email) && isPhoneValid

  return (
    <Modal show={show} onClose={onClose} size="l" title={t('Datos del cliente')}>
      <Styles.Container>
        <Text type="bodyMRegular">
          {t('Edita los datos del cliente que se utilizarán para el envío de comunicaciones')}
        </Text>
        <InputWithLabel label={t('Nombre cliente')} value={customer?.name} disabled />
        <InputWithLabel
          label={t('Correo electrónico')}
          value={customer?.email}
          onChange={handleChangeEmail}
          error={!validateEmail(customer?.email)}
          helperText={!validateEmail(customer?.email) && t('Este campo es obligatorio')}
        />
        <Styles.PhoneRow>
          <PhonePrefixSelector
            label={t('Prefijo')}
            value={customer?.phone?.prefix}
            onChange={handleChangePhonePrefix}
          />
          <InputWithLabel
            fullWidth
            label={t('Teléfono')}
            value={customer?.phone?.number}
            onChange={handleChangePhoneNumber}
            error={!isPhoneValid}
            helperText={!isPhoneValid && t('Este campo es obligatorio')}
          />
        </Styles.PhoneRow>
        <LanguageSelector
          supportedLanguages={supportedLanguages}
          value={customer?.language}
          onChange={handleChangeLanguage}
        />
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            onClick={handleSave}
            loading={loading}
            disabled={loading || !isFormValid}
            defaultLabel={t('Guardar')}
            loadingLabel={t('Guardando')}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default EditCustomerDetailModal
